import { render } from "./BillingInformations.vue?vue&type=template&id=8a3d8ab0"
import script from "./BillingInformations.vue?vue&type=script&lang=js"
export * from "./BillingInformations.vue?vue&type=script&lang=js"

import "./BillingInformations.vue?vue&type=style&index=0&id=8a3d8ab0&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/BillingInformations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a3d8ab0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a3d8ab0', __exports__)) {
    console.log('reload')
    api.reload('8a3d8ab0', __exports__)
  }
  
  module.hot.accept("./BillingInformations.vue?vue&type=template&id=8a3d8ab0", () => {
    console.log('re-render')
    api.rerender('8a3d8ab0', render)
  })

}


export default __exports__